import React from "react";
import cs from "classnames"
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

export type NavigationLayoutProps = {
    pageTitle: string
    description?: string
    hideNavigation?: boolean
    children: React.ReactNode;
}

const NavigationLayout: React.FC<NavigationLayoutProps> = ({pageTitle, description, hideNavigation, children}) => {
    return <div className={"h-full flex flex-col overflow-scroll relative"}>
        <Head>
            <title>{pageTitle}</title>
            {description && <meta name="description" content={description}/>}
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>
            {/*<meta name="description" content="Generated by create next app" />*/}
            <link rel="icon" href="/birb.svg"/>
            <meta property="og:title" content={pageTitle}/>
            <meta property="og:image" content="https://notionsender.com/card-preview.png" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://notionsender.com/card-preview.png" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@NotionSender" />
            <meta name="twitter:creator" content="@NotionSender" />
        </Head>
        {!hideNavigation &&
          <div
            className={"flex-none my-4 h-16 md:h-24 flex items-center mx-4 sm:mx-24 md:mx-32 lg:mx-32 xl:mx-48 2xl:mx-auto max-w-7xl"}>

            <Link href={"/"}>
              <div className={"flex items-center cursor-pointer"}>
                <div className={"relative h-16 w-16"}>
                  <Image src={"/birb.svg"} alt={"Notion Sender email to notion"} layout={"fill"}/>
                </div>
                <div className={"text-2xl font-bold px-2 text-gray-700"}>
                  NotionSender
                </div>
              </div>
            </Link>

          </div>
        }
        <div className={"flex-1 grow"}>{children}</div>
    </div>
}
export default NavigationLayout;